module.exports = __webpack_public_path__ + "img/2-3.e7178f0d.svg";